import axios from 'axios'

const state = () => ({
    fotos: []
})

const getters = {
    fotos(state) {
        return state.fotos
    }
}

const mutations = {
    SET_FOTOS(state, payload){
        state.fotos = payload
    }
}

const actions = {
    getFotos({commit}){
        // let myPayload = Object.assign({}, payload)
        // myPayload.page -= 1
        axios.get('https://api.geomalaka.uz/api/main/fotogalery/')
            .then((res)=>{
                commit("SET_FOTOS", res.data)
            })
            .catch((error)=>{
                console.log(error)
            })
    },
}

export default{
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}

